var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpFeatureIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v110H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.453 92.182H39.209a5.183 5.183 0 0 1-4.99-3.777l-6.544-23.217h53.772l-5.973 23.108a5.183 5.183 0 0 1-5.021 3.886ZM81.823 60.597H27.295a2.295 2.295 0 0 0 0 4.59h54.528a2.295 2.295 0 1 0 0-4.59ZM36.7 65.186l5.72 26.994M72.417 65.186l-5.72 26.994M47.12 65.186l3.401 26.994M61.996 65.186 58.595 92.18M54.558 27.473v3.691",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.585 22.737c0 2.616-.907 4.736-2.027 4.736s-2.027-2.12-2.027-4.736c0-2.617 2.027-4.737 2.027-4.737s2.027 2.12 2.027 4.737Z",
    fill: "#fff",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.85 29.687h2.253M36.43 29.687h2.252M34.767 33.603V31.35M34.767 28.024V25.77",
    stroke: "#C3985A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m54.516 44.683 2.468.08v-.08M56.984 40.044v4.639",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.964 32.044a1.087 1.087 0 0 0-1.067-.88H53.22a1.087 1.087 0 0 0-1.087 1.087v12.356l2.383.078",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.516 44.683H49.84a21.076 21.076 0 0 0-20.433 15.914M69.663 47.202c.877.474 1.72 1.009 2.522 1.601M74.904 51.202a21.114 21.114 0 0 1 3.744 5.39M80.104 60.596c-.052-.208-.11-.414-.17-.62M66.359 45.77a21.044 21.044 0 0 0-6.687-1.087h-2.688M54.516 44.683h2.468",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.904 51.202a3.425 3.425 0 1 1 3.744 5.39",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.904 51.202a3.424 3.424 0 0 0 3.744 5.39",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.934 59.977a7.048 7.048 0 1 0-7.749-11.174M79.934 59.977a7.045 7.045 0 0 1-7.75-11.174M56.963 32.044a7.052 7.052 0 1 1 .02 8",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.326 39.413a3.426 3.426 0 1 0-1.097-6.764 3.426 3.426 0 0 0 1.097 6.764ZM56.964 32.044a7.037 7.037 0 0 0 .02 8M66.358 45.77l14.924-14.334a1.14 1.14 0 0 1 1.613.033l.72.75a1.141 1.141 0 0 1-.032 1.613l-13.92 13.37M66.358 45.77l-10.285 9.878a1.14 1.14 0 0 0-.032 1.614l.72.75a1.141 1.141 0 0 0 1.613.032l11.288-10.842",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.724 46.284a2.706 2.706 0 1 0 0-5.412 2.706 2.706 0 0 0 0 5.412Z",
    stroke: "#C3985A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpFeatureIcon4);
export default __webpack_public_path__ + "static/media/mp-feature-icon-4.06367bd361a108bb9841587dfea9d7fe.svg";
export { ForwardRef as ReactComponent };